import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import { FormattedMessage } from 'react-intl';

const Alert = ({
  text,
  open,
  onOk,
  okText,
  onCancel,
  cancelText,
}) => (
  <Dialog
    open={open}
    actions={[
      <FlatButton
        label={cancelText}
        secondary
        onClick={onCancel}
      />,
      <FlatButton
        data-cy="button-ok"
        label={okText}
        primary
        onClick={onOk}
      />]}
  >
    {text}
  </Dialog>
);

Alert.propTypes = {
  text: PropTypes.node,
  open: PropTypes.bool,
  onOk: PropTypes.func,
  okText: PropTypes.node,
  onCancel: PropTypes.func,
  cancelText: PropTypes.node,
};

Alert.defaultProps = {
  okText: <FormattedMessage id="alert.ok" />,
  cancelText: <FormattedMessage id="alert.cancel" />,
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Alert.js